import Config from 'lib/Config';
import { debug } from 'lib/utils/debug';
import React, { useEffect } from 'react';
import Helmet from 'react-helmet';
import './style.scss';

const Logout = (props) => {
    //let navigate = useNavigate();
    useEffect(async () => {
        console.log(`Logging out...`);
        debug(props.auth.user, 'Logging user out (login page)');

        await props.auth.logout('/');
        //navigate('/');
        // we force the refresh to try to deal with a live bug in undeterminable auth state.
        setTimeout(() => {
            console.log(`REDIRECT`)
            window.location.href = '/';
        }, 0);
    }, []);

    return (
        <div className="logout pad lg flex1 flex-col-center-both">

            <Helmet><title>{Config.SITE_TITLE_PREFIX} - Logout</title></Helmet>

            <p className="font-plain-large center">Logging out...</p>
        </div>
    );
};

export default Logout;